import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import dayjs from "dayjs";

type State = {
  dsChiDinh: any[];
};

const initialState: State = {
  dsChiDinh: [],
};

export const commonSlice = createSlice({
  name: "listAssign",
  initialState: initialState,
  reducers: {
    setListAssign: (state = initialState, action: PayloadAction<any>) => {
      return {
        dsChiDinh: action.payload.map((it) => ({
          ...it,
          ngayChiDinh: dayjs(),
        })),
      };
    },
  },
});

export const { setListAssign } = commonSlice.actions;

export default commonSlice.reducer;
